import { queryOptions } from "@tanstack/react-query";
import type {
  OrgMembersData,
  OrgMembersResponse,
} from "@/app/org-members/types";
import { getCoordinatorApi } from "@/lib/api";
import { orgMembersKeys } from "./query-keys";

const fetchOrgMembers = async (
  organizationId: string
): Promise<OrgMembersData> => {
  const client = getCoordinatorApi({ organizationId });
  const { data } = await client.get<OrgMembersResponse>("/members");
  return data.data;
};

export const orgMembersQueryOptions = (organizationId: string) =>
  queryOptions<OrgMembersData>({
    queryKey: orgMembersKeys.list(organizationId),
    queryFn: () => fetchOrgMembers(organizationId),
  });
